import { useNavigate } from 'react-router';
import * as api from '@/lib/api-client';

/** Logout of the sidebar: API call, then `/login`. A failure propagates. */
export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  return async () => {
    await api.logout();
    navigate('/login');
  };
}
